<form *ngIf="form != null" class="form-container" [formGroup]="form">
    <div class="form-item-container" title="{{notUsableSeatFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>NotUsableSeatFactor</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="notUsableSeatFactor">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{oppositeDoorReductionFactorValueTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>OppositeDoorReductionFactorValue</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="oppositeDoorReductionFactorValue">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{beforeSeatReductionFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>BeforeSeatReductionFactorValue</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="beforeSeatReductionFactorValue">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{distanceBetweenPeopleTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>DistanceBetweenPeople</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="distanceBetweenPeople">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{distanceBetweenPeopleAisleTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>DistanceBetweenPeopleAisle</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="distanceBetweenPeopleAisle">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{distanceBetweenPeopleStairsTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>DistanceBetweenPeopleStairs</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="distanceBetweenPeopleStairs">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{rackCapacityRoundingThresholdTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>RackCapacityRoundingThreshold</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="rackCapacityRoundingThreshold">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{minimumUnderSeatHeightTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>MinimumUnderSeatHeight</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="minimumUnderSeatHeight">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{overheadHeightReductionFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>OverheadHeightReductionFactor</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="overheadHeightReductionFactor">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{overheadLengthReductionFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>OverheadLengthReductionFactor</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="overheadLengthReductionFactor">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{overheadLengthReductionThresholdTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>OverheadLengthReductionThreshold</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="overheadLengthReductionThreshold">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{handleReductionFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>HandleReductionFactor</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="handleReductionFactor">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{overencumberFactorTooltip}}">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>OverencumberFactor</mat-label>
            <input matInput type="number" autoComplete="off" formControlName="overencumberFactor">
        </mat-form-field>
    </div>
    <div class="form-item-container" title="{{securityAdjustmentFactorTooltip}}">
        <div class="title">
            <label><b>SecurityAdjustmentFactor</b></label>
        </div>
        <app-grid-list [data]="gridDataSecurityAdjustmentFactor"></app-grid-list>
    </div>
    <div class="form-item-container" title="{{luggagePerFoldingSeatTooltip}}">
        <div class="title">
            <label><b>LuggagePerFoldingSeat</b></label>
        </div>
        <app-grid-list [data]="gridDataLuggagePerFoldingSeat"></app-grid-list>
    </div>
</form>